import {
  Button,
  H3,
  Modal,
  P,
  PropsModal,
  lightTheme,
} from '@vgrubs/components';

export const DeleteScheduleModal = ({
  deleteModal,
  closeModal,
  handleDeleteSchedule,
}: PropsModal & {
  deleteModal: boolean;
  handleDeleteSchedule: () => void;
}) => {
  return (
    <Modal isOpen={deleteModal} closeModal={closeModal} logo={false}>
      <H3 $mb="24" $color={lightTheme.primary}>
        Are you sure
      </H3>
      <P $mb="40">Are you sure you want to delete this schedule?</P>

      <Button $selected $w="100%" $mb="8" onClick={handleDeleteSchedule}>
        Confirm
      </Button>

      <Button $selected $w="100%" $gray onClick={() => closeModal?.()}>
        Cancel
      </Button>
    </Modal>
  );
};
